import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Navigation } from 'swiper';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { SliderCardSmall } from 'components';
import { items } from 'pages/blog_data/2';
import './RealatedBlogSlider.scss';
const ReletedBlogsSlider = ({ title }) => {
	return (
		<Row className='custom-container-only-left section-wrapper mx-0 position-relative w-100 d-flex align-items-center related-blog-slider'>
			<Col cols={12} className='px-0'>
				<h2 className='related-blog-slider-title'>{title}</h2>
			</Col>
			<Col cols={12} className='position-relative slider-container px-0'>
				<Swiper
					slidesPerView={1}
					spaceBetween={5}
					navigation={{
						nextEl: '.button-right',
						prevEl: '.button-left',
					}}
					breakpoints={{
						370: {
							slidesPerView: 1.5,

							spaceBetween: 30,
						},

						600: {
							slidesPerView: 2,
							spaceBetween: 30,
						},
						768: {
							slidesPerView: 2.5,
							spaceBetween: 30,
						},
						1440: {
							slidesPerView: 3.0,
							spaceBetween: 30,
						},
						1700: {
							slidesPerView: 4.2,
							spaceBetween: 30,
						},
					}}
					modules={[Navigation]}
					className='relatedBlogSlider'
				>
					{items.map((item) => (
						<SwiperSlide>
							<SliderCardSmall item={item} />
						</SwiperSlide>
					))}
				</Swiper>
				<div className='button-right'></div>
				<div className='button-left'></div>
			</Col>
		</Row>
	);
};

export default ReletedBlogsSlider;
